import { Image, View } from "react-native";
import { ImageStyle, ViewStyle } from "react-native";
import { ms } from "@/ui/moderateScale";
import { useState } from "react";
import { Colors } from "@/constants";

export const icons = {
  edit: "edit.svg",
  history: "history.svg",
  addCircle: "add_circle.svg",
  helpCircle: "help_circle.svg",
  undo: "undo.svg",
  caretUpFilled: "caret_up_filled.svg",
  redo: "redo.svg",
  share: "share.svg",

  searchBar: "search_bar.svg",
  close: "close.svg",
  home: "home.svg",
  rocket: "rocket.svg",
  support: "support.svg",
  email: "email.svg",
  caretRight: "caret_right.svg",
  infinity: "infinity.png",
  apple: "apple.svg",
  google: "google.svg",
  link: "link.svg",
  moreHorizontal: "more_horizontal.svg",
  moreVertical: "more_vertical.svg",
  questionMark: "question_mark.svg",
  record: "record.svg",
  text: "text.svg",
  folder: "folder.png",
  upload: "upload.svg",
  caretDownFilled: "caret_down_filled.svg",
  mic: "mic.svg",
  pen: "pen.svg",
  bin: "bin.svg",
  plus: "plus.svg",
  play: "play.svg",
  pause: "pause.svg",
  download: "download.svg",
  tick: "tick.svg",
  copy: "copy.svg",
  chat: "chat.svg",
  send: "send.svg",
  actionCreateText: "action_create_text.svg",
  actionOcrPdf: "action_ocr_pdf.svg",
  actionUploadPdf: "action_upload_pdf.svg",
  actionYoutubeVideo: "action_youtube_video.svg",
  tickCircle: "tick_circle.svg",
};

export type IconType = keyof typeof icons;

const Icon = ({
  icon,
  style = {},
  containerStyle = {},
  enableHover = false,
}: {
  icon: keyof typeof icons;
  style?: ImageStyle;
  containerStyle?: ViewStyle;
  enableHover?: boolean;
}) => {
  let baseUrl = "/icons";
  const [hoverIn, setHoverIn] = useState(false);

  return (
    <View
      style={{
        ...(containerStyle || {}),
        ...(enableHover && {
          width: ms(32),
          height: ms(32),
          backgroundColor: hoverIn ? Colors.text + "08" : "transparent",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: ms(8),
        }),
      }}
    >
      <div
        onMouseEnter={() => setHoverIn(enableHover)}
        onMouseLeave={() => setHoverIn(false)}
        style={{
          WebkitTouchCallout: "none",
          WebkitUserSelect: "none",
          KhtmlUserSelect: "none",
          MozUserSelect: "none",
          msUserSelect: "none",
          userSelect: "none",
          touchAction: "manipulation",
        }}
      >
        <Image
          source={{
            uri: `${baseUrl}/${icons[icon]}`,
          }}
          alt={icon}
          style={{ width: ms(24), height: ms(24), ...style }}
        />
      </div>
    </View>
  );
};

export default Icon;
